module.exports = __webpack_public_path__ + "static/media/cannesBWSmall.82ab7b6a.jpg";